import { IGetSymbolsChecksOptions, ISymbolsHandler } from './getSymbolsChecks.types';
import { handlerBotCommands } from './handlers/handlerBotCommands/handlerBotCommands';
import { handlerCloseSquareBracket } from './handlers/handlerCloseSquareBracket/handlerCloseSquareBracket';
import { handlerDog } from './handlers/handlerDog/handlerDog';
import { handlerEscapedText } from './handlers/handlerEscapedText/handlerEscapedText';
import { handlerKeyWord } from './handlers/handlerKeyWord/handlerKeyWord';
import { handlerLink } from './handlers/handlerLink/handlerLink';
import { handlerOpenSquareBracket } from './handlers/handlerOpenSquareBracket/handlerOpenSquareBracket';
import { handlerStars } from './handlers/handlerStars/handlerStars';
import { handlerStroke } from './handlers/handlerStroke/handlerStroke';
import { handlerUnderline } from './handlers/handlerUnderline/handlerUnderline';

export const getSymbolsChecks = (
  opts: IGetSymbolsChecksOptions
): Record<string, ISymbolsHandler> => {
  const { keyWords, userMentions, hasBotCommands } = opts;
  const symbolsHandlers: Record<string, ISymbolsHandler> = {
    '*': handlerStars,
    '~': handlerStroke,
    _: handlerUnderline,
    '.': handlerLink,
    '[': handlerOpenSquareBracket,
    ']': handlerCloseSquareBracket,
    '@': handlerDog({ userMentions }),
    '`': handlerEscapedText,
    '/': handlerBotCommands({ hasBotCommands }),
  };

  const keyWordsHandlers: Record<string, ISymbolsHandler> = {};

  for (const { keyWord, keyWordType } of keyWords) {
    keyWordsHandlers[keyWord[0]] = handlerKeyWord({
      keyWord,
      keyWordType,
      symbolHandler: symbolsHandlers[keyWord[0]],
    });
  }

  return {
    ...symbolsHandlers,
    ...keyWordsHandlers,
  };
};
